export class PushTelemetryData {
	private _pushEventTriggeredCount = 0;
	private _pushEventExecutedCount = 0;
	private _pushEventSnoozedCount = 0;
	private _timeSinceLastPushEvent = 0;

	get pushEventTriggeredCount(): number {
		return this._pushEventTriggeredCount;
	}

	set pushEventTriggeredCount(value: number) {
		this._pushEventTriggeredCount = value;
	}

	get pushEventExecutedCount(): number {
		return this._pushEventExecutedCount;
	}

	set pushEventExecutedCount(value: number) {
		this._pushEventExecutedCount = value;
	}

	get pushEventSnoozedCount(): number {
		return this._pushEventSnoozedCount;
	}

	set pushEventSnoozedCount(value: number) {
		this._pushEventSnoozedCount = value;
	}

	get timeSinceLastPushEvent(): number {
		return this._timeSinceLastPushEvent;
	}

	set timeSinceLastPushEvent(value: number) {
		this._timeSinceLastPushEvent = value;
	}
}
